import type { ClientMouseCursorJSON, ClientId, UnixTimestampMilliSeconds, UserId } from 'balus-common';

export class ClientMouseCursor {
  public readonly id: ClientId;
  public readonly x: number;
  public readonly y: number;
  public readonly userId: UserId;
  public readonly name: string;
  public readonly imageUrl: string | null;
  public readonly isAnonymous: boolean;
  public readonly updatedAt: UnixTimestampMilliSeconds | undefined;

  constructor(
    id: ClientId,
    x: number,
    y: number,
    userId: UserId,
    name: string,
    imageUrl: string | null,
    isAnonymous: boolean,
    updatedAt?: number
  ) {
    this.id = id;
    this.x = x;
    this.y = y;
    this.userId = userId;
    this.name = name;
    this.imageUrl = imageUrl;
    this.isAnonymous = isAnonymous;
    this.updatedAt = updatedAt;
  }

  dump(): ClientMouseCursorJSON {
    return {
      id: this.id,
      x: this.x,
      y: this.y,
      userId: this.userId,
      name: this.name,
      imageUrl: this.imageUrl,
      isAnonymous: this.isAnonymous,
      updatedAt: this.updatedAt,
    };
  }

  static load(dump: ClientMouseCursorJSON): ClientMouseCursor {
    return new ClientMouseCursor(
      dump.id,
      dump.x,
      dump.y,
      dump.userId,
      dump.name,
      dump.imageUrl,
      dump.isAnonymous,
      dump.updatedAt
    );
  }
}
